import { useContext } from "react";
import { Modal } from "react-bootstrap";
import { SelectedImageContext } from "../../../SelectedImageContext";
import ReactiveButton from "reactive-button";

interface ModalProps {
    showImgModal: boolean;
    handleCloseModal: (val: boolean) => void;
    setOpenCamera: (val: boolean) => void;
    UploadImage: () => void;
    isReady?: boolean;
    uploadRequestState?: "idle" | "loading" | "success" | "error";
}


const ImageModal: React.FC<ModalProps> = ({
    showImgModal,
    handleCloseModal,
    UploadImage,
    isReady = true,
    uploadRequestState = "idle",
}) => {

    const { chatAttachment, selectedFriendImg } = useContext(SelectedImageContext);
    const isUploading = uploadRequestState === "loading";

    return (
        <>
            <Modal
                centered
                show={showImgModal}
                onHide={() => {
                    if (!isUploading) {
                        handleCloseModal(false);
                    }
                }}
                keyboard={!isUploading}
            >
                <Modal.Body className="text-center">
                    {chatAttachment && (
                        <img
                            src={URL.createObjectURL(chatAttachment)}
                            className="desktopUI"
                            alt="Attachment"
                        />
                    )}
                    {selectedFriendImg && (
                        <img
                            src={URL.createObjectURL(selectedFriendImg)}
                            className="desktopUI"
                            alt="Selected Friend Image"
                        />
                    )}
                </Modal.Body>
                
                <Modal.Footer>
                    <div className="col-12 mt-2 mb-2">
                        <ReactiveButton
                            buttonState={uploadRequestState}
                            onClick={UploadImage}
                            color={'yellow'}
                            idleText={isReady ? 'Upload Photo' : 'Preparing...'}
                            loadingText={'Uploading'}
                            successText={'Uploaded'}
                            errorText={'Error'}
                            type={'button'}
                            className="link btns btnMO justify-content-center d-flex align-content-center w-100"
                            outline={false}
                            shadow={false}
                            rounded={false}
                            size={'normal'}
                            block={true}
                            messageDuration={2000}
                            disabled={!isReady || isUploading}
                            buttonRef={null}
                            width={'100%'}
                            height={null}
                            animation={true}
                        />
                    </div>
                    <button
                        className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                        onClick={() => { handleCloseModal(false) }}
                        disabled={isUploading}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ImageModal
